import React from 'react'
import { Html } from 'react-konva-utils'

import { useAppSelector } from '@/hooks/redux'
import { PLACEMENT } from '@/store/appSlice'

interface HtmlKonvaElementProps {
  x: number
  y: number
  children: React.ReactNode
  placement?: PLACEMENT
}
const HtmlKonvaElement: React.FC<HtmlKonvaElementProps> = ({
  x,
  y,
  children,
  placement = PLACEMENT.CENTER,
}) => {
  const scale = useAppSelector((state) => state.app.canvasScale[placement] || 1)
  return (
    <Html
      // key={Date.now().toString()}
      groupProps={{
        x: x,
        y: y,
        scaleX: 1 / scale,
        scaleY: 1 / scale,
      }}
    >
      {children}
    </Html>
  )
}

export default HtmlKonvaElement
